<template>
  <BaseModal :title="modalTitle" :value="open" @close="close" headerClass="py-3">
    <template>
      <form @submit.prevent="createMenu">
        <!-- Menu Name -->
        <div class="space-y-1">
          <label class="block text-sm font-bold text-gray-700">
            {{ translate('Menu Name')
            }}<span class="text-red-500"> *</span>
          </label>
          <input
            type="text"
            v-model="menuName"
            :placeholder="translate('Enter menu name')"
            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            required
          />
        </div>

        <!-- Submit button -->
        <div class="mt-5 sm:mt-6 text-center">
          <button
            id="menus.button.addmenu"
            type="submit"
            class="inline-flex justify-center w-1/2 rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm"
            :class="{
              'opacity-50 cursor-not-allowed': isSubmitting || !isFormValid,
            }"
            :disabled="isSubmitting || !isFormValid"
          >
            <i v-if="isSubmitting" class="fas fa-spinner fa-spin mr-2"></i>
            {{ submitButtonText }}
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import { translations } from '@/mixins';
import { Menu as MenuApi } from '@/services/SOLO';
import BaseModal from '@/components/V2/Modals/BaseModal.vue';

export default {
  name: 'MenuAddModal',

  components: {
    BaseModal,
  },

  mixins: [translations],

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      menuName: '',
      isSubmitting: false,
      validationErrors: {
        name: false,
      },
      showValidationErrors: false,
    };
  },

  computed: {
    modalTitle () {
      return this.translate('Add Menu');
    },

    submitButtonText () {
      return this.translate('SAVE');
    },

    isFormValid () {
      const hasNameError = !this.menuName;
      return !hasNameError;
    },

    menuData () {
      return {
        label: this.menuName,
      };
    },

    open () {
      return this.isOpen;
    },
  },

  methods: {
    close () {
      this.$emit('close');
    },

    async createMenu () {
      this.isSubmitting = true;
      try {
        await MenuApi.create(this.menuData);
        this.$notify({
          title: 'MENU CREATED!',
          verticalAlign: 'bottom',
          horizontalAlign: 'left',
          message: 'Menu has been created successfully',
          type: 'success',
          icon: 'fas fa-check',
        });
        this.$emit('getMenus');
        this.$emit('close');
      } catch (error) {
        this.$notify({
          title: 'SYSTEM ERROR!',
          verticalAlign: 'bottom',
          horizontalAlign: 'left',
          message: 'Something went wrong, please try again!',
          type: 'danger',
          icon: 'fas fa-bomb',
        });
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
